
export const isMenuHiddden = <T>(arr: T[], input: T[]): boolean => {
    for (const num of input) {
      if (arr.includes(num)) {
        return false;
      }
    }
    return true;
  }